export const namespaced = true;

export const state = {
    videos: [],
}

export const mutations = {
    FETCH(state, videos) {
        state.videos = videos;
    },
}

export const actions = {

    async fetch({ commit, dispatch }) {
        try {
            const res = await axios.get(`/api/video-instructions`);
            commit('FETCH', res.data);
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    }

}
